import React, { useState, useEffect } from 'react';

function AnimatedOrbs() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsVisible(scrollPosition <= 800);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`animated-orbs ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="animated-orbs__orb orb-1"></div>
      <div className="animated-orbs__orb orb-2"></div>
      <div className="animated-orbs__orb orb-3"></div>
      <div className="animated-orbs__orb orb-4"></div>
      <div className="animated-orbs__orb orb-5"></div>
    </div>
  );
}

export default AnimatedOrbs; 